<table
  mat-table
  [dataSource]="dataSource"
  matSort
  (matSortChange)="sortData($event)"
  matSortActive="name"
  matSortDirection="asc">
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header><span translate="common/name"></span></th>
    <td mat-cell *matCellDef="let row">
      <span (click)="roleSelected.emit({ id: row.id })">
        <span class="users-roles-table-link">{{ row.name }}</span>
      </span>
    </td>
  </ng-container>

  <ng-container matColumnDef="nusers">
    <th mat-header-cell *matHeaderCellDef mat-sort-header><span translate="users_roles/number_of_users"></span></th>
    <td mat-cell *matCellDef="let row">{{ row.nusers }}</td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

  <!-- Row shown when there is no matching data. -->
  <tr class="mat-row" *matNoDataRow>
    <td
      *ngIf="loading; else noResults"
      class="mat-cell"
      [attr.colspan]="displayedColumns.length"
      translate="loading"></td>
    <ng-template #noResults>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length" translate="no-results"></td>
    </ng-template>
  </tr>
</table>
